export default {

    computed: {
        //出入库装箱
        getBoxingColumns() {
            return [
                {
                    title: 'ERP SKU',
                    key: 'sku',
                },
                {
                    title: this.$t('fbb.alloment.qty', { defaultValue: '装箱数' }),
                    key: 'qty',
                },
                {
                    title: this.$t('fbb.inbound.case_code', { defaultValue: '箱码' }),
                    key: 'boxBarcode',
                },
                {
                    title: this.$t('fbb.alloment.tray_bar_code', { defaultValue: '托盘码' }),
                    key: 'trayBarcode',
                },
                {
                    title: this.$t('fbb.alloment.outer_box_weight', { defaultValue: '外箱毛重' }) + '（g）',
                    key: 'cartonGrossWeight',
                },
                {
                    title: this.$t('fbb.alloment.outer_box_size', { defaultValue: '外箱长*宽*高' }) + '（cm）',
                    key: 'cartonLength',
                    render(h, { row }) {
                        return <div>
                            {row.cartonLength}*
							{row.cartonWidth}*
							{row.cartonHeight}(cm*cm*cm)
							</div>
                    }
                }
            ];
        },
        // log 类型转换
        getLogActionMap() {
            // PUSH_WAREHOUSE(1,"推送仓库"),
            // CANCEL_PUSH_WAREHOUSE(2,"取消推送仓库"),
            // TRACKING_PUSH_WAREHOUSE(3,"tracking推送仓库"),
            // WRITE_BACK_BOSS(4,"回传boss"),
            // WRITE_BACK_FBB(5,"回写云仓"),
            // INVENTORY_TASK_WRITE_BACK(6,"库存变动回写boss"),
            // INVENTORY_TASK_WRITE_BACK_VIRTUAL(7,"库存变动回写虚拟库存模块"),
            // CHECK(8,"审核"),
            // PUSH_ATTACH(9,"推送附件"),

            // WMS_WRITE_BACK_FBB(10,"wms回传fbb"),
            // WAREHOUSEDOCKING_WRITE_BACK_FBB(11,"warehousedocking回传fbb")
            // ETURN_TRACKING(4,"tracking回写Boss"),
            // PUSH_ATTACH(10,"推送附件"),
            // OPERATE_TYPE_TASK_WRITE_BACK_NEW(13,"库存流水回写"),
            // UN_ACTIVE(90,"失效"),
            // CREATE(100,"创建"),
            // UPDATE(200,"更新"),
            // SUBMIT(210,"提交"),
            // SAVE_SUBMIT(230,"保存并提交"),
            // CANCEL_APPLY(240,"撤回申请"),
            // SAVE(250,"保存"),
            // EDIT(260,"编辑"),
            // DISCHARGE(290,"卸货"),
            // DELETED(300,"删除"),
            // CANCEL(400,"取消"),
            // CHECK_APPROVE(500,"审核通过"),
            // CHECK_REFUSE(600,"审核拒绝"),
            // PUSH_DASHBOARD(610,"BOSS处理"),
            // OUTBOUNDED(710,"已出库"),
            // GEN_BOXLABEL(830,"生成箱标"),
            // ORDER_PUSH_WAREHOUSE(930,"推送仓库");
            return {
                // '1': "推送仓",
                // '2': "取消推送仓库",
                // '3': "tracking推送仓库",
                '4': this.$t('fbb.alloment.tracking_rewrite_boss', { defaultValue: "tracking回写Boss" }),
                // '5': "回写云仓",
                // '6': "库存变动回写boss",
                // '7': "库存变动回写虚拟库存模块",
                // '8': "审核",
                // '9': "推送附件",
                // '10': "wms回传fbb",
                // '11': "warehousedocking回传fbb",
                '10': this.$t('fbb.alloment.push_attachment', { defaultValue: "推送附件" }),
                '13': this.$t('fbb.alloment.stock_write_back', { defaultValue: "库存流水回写" }),
                '90': this.$t('fbb.alloment.loss_effect', { defaultValue: "失效" }),
                '100': this.$t('global.common.create', { defaultValue: "创建" }),
                '200': this.$t('fbb.alloment.update', { defaultValue: "更新" }),
                '210': this.$t('global.common.update_submit', { defaultValue: "提交" }),
                '215': this.$t('fbb.alloment.cancel_audit', { defaultValue: "撤销审核" }),
                '230': this.$t('fbb.alloment.save_and_commit', { defaultValue: "保存并提交" }),
                '240': this.$t('fbb.alloment.back_apply', { defaultValue: "撤回申请" }),
                '250': this.$t('global.common.save', { defaultValue: "保存" }),
                '260': this.$t('global.common.edit', { defaultValue: "编辑" }),
                '290': this.$t('fbb.reserveinbound.discharge', { defaultValue: "卸货" }),
                '300': this.$t('global.common.delete', { defaultValue: "删除" }),
                '400': this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                '500': this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                '600': this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                '610': this.$t('fbb.alloment.boss_deal_with', { defaultValue: "BOSS处理" }),
                '710': this.$t('fbb.alloment.has_outbound_number', { defaultValue: "已出库" }),
                '720': this.$t('global.datepicker.confirm', { defaultValue: "确认" }),
                '800': this.$t('global.common.finished', { defaultValue: "已完成" }),
                '830': this.$t('fbb.inbound.rawcrates_standard', { defaultValue: "生成箱标" }),
                '930': this.$t('fbb.alloment.push_warehouse', { defaultValue: "推送仓库" }),
                '1010': this.$t('fbb.alloment.inbound_back_boss', { defaultValue: "调拨入库执行单回传boss" })
            }
        },
        getManageBillType(){
            return [ {
                label: this.$t('fbb.alloment.alloment_out', { defaultValue: "调拨出库" }),
                value: 1
            }, {
                label: this.$t('fbb.alloment.alloment_in', { defaultValue: "调拨入库" }),
                value: 2
            }/* , {
                label: "Onsite调拨-跨仓",
                value: 3
            } */]
        },
        getErrorSimpleType(){
            return [ {
                label: this.$t('fbb.inbound.error_push', { defaultValue: "推送异常" }),
                value: 1
            }, {
                label: this.$t('fbb.inbound.error_approve', { defaultValue: "审核异常" }),
                value: 3
            },  {
                label: this.$t('fbb.alloment.confirm_error', { defaultValue: "确认异常" }),
                value: 5
            },  {
                label: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                value: 7
            }, {
                label: this.$t('fbb.inbound.error_attachment_push', { defaultValue: "附件推送异常" }),
                value: 8
            }, {
                label: this.$t('fbb.alloment.wms_back_fbb_error', { defaultValue: "wms回传fbb异常" }),
                value: 11
            },  {
                label: this.$t('fbb.alloment.dock_back_fbb_error', { defaultValue: "dock回传fbb异常" }),
                value: 14
            },  {
                label: this.$t('fbb.alloment.action_order_push_error', { defaultValue: "执行单推送异常" }),
                value: 18
            }, {
                label: this.$t('fbb.inbound.error_complete', { defaultValue: "完成异常" }),
                value: 19
            }]
        },
        getErrorType(){
            return [ {
                label: this.$t('fbb.inbound.error_push', { defaultValue: "推送异常" }),
                value: 1
            }, {
                label: this.$t('fbb.inbound.error_push', { defaultValue: "推送异常" }),
                value: 2
            }, {
                label: this.$t('fbb.inbound.error_approve', { defaultValue: "审核异常" }),
                value: 3
            }, {
                label: this.$t('fbb.inbound.error_approve', { defaultValue: "审核异常" }),
                value: 4
            }, {
                label: this.$t('fbb.alloment.confirm_error', { defaultValue: "确认异常" }),
                value: 5
            }, {
                label: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                value: 6
            }, {
                label: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                value: 7
            }, {
                label: this.$t('fbb.inbound.error_attachment_push', { defaultValue: "附件推送异常" }),
                value: 8
            }, {
                label: this.$t('fbb.inbound.error_attachment_push', { defaultValue: "附件推送异常" }),
                value: 9
            }, {
                label: this.$t('fbb.alloment.wms_back_fbb_error', { defaultValue: "wms回传fbb异常" }),
                value: 11
            }, {
                label: this.$t('fbb.alloment.wms_back_fbb_error', { defaultValue: "wms回传fbb异常" }),
                value: 12
            }, {
                label: this.$t('fbb.alloment.dock_back_fbb_error', { defaultValue: "dock回传fbb异常" }),
                value: 14
            }, {
                label: this.$t('fbb.alloment.dock_back_fbb_error', { defaultValue: "dock回传fbb异常" }),
                value: 15
            }, {
                label: this.$t('fbb.alloment.action_order_push_error', { defaultValue: "执行单推送异常" }),
                value: 18
            }, {
                label: this.$t('fbb.inbound.error_complete', { defaultValue: "完成异常" }),
                value: 19
            }, {
                label: this.$t('fbb.inbound.error_complete', { defaultValue: "完成异常" }),
                value: 20
            }]
            },
        //单据类型
        getBillType() {
            //             HOUSE_TO_HOUSE(0,"调拨(仓-仓)"),          //调拨(仓-仓)
            // TRANSFER_OUT(1,"B2B调拨出库"),            //B2B调拨出库
            // TRANSFER_IN(2,"B2B调拨入库"),             //B2B调拨入库
            // ONSITE_OUTSIDE(3,"onsite库外调拨"),          //onsite库外调拨
            // ONSITE_INSIDE(4,"onsite库内调拨");           //onsite库内调拨
            return [{
                label: this.$t('fbb.alloment.alloment_warehouse_to_warehouse', { defaultValue: "调拨(仓-仓)" }),
                value: 0
            }, {
                label: this.$t('fbb.alloment.alloment_out', { defaultValue: "调拨出库" }),
                value: 1
            }, {
                label: this.$t('fbb.alloment.alloment_in', { defaultValue: "调拨入库" }),
                value: 2
            }, {
                label: this.$t('fbb.alloment.onsite_alloment', { defaultValue: "Onsite调拨" }),
                value: 4
            }/* , {
                label: "Onsite调拨-跨仓",
                value: 3
            } */]
        },
        getInventoryType() {
            return [{
                label: this.$t('fbb.inbound.available_stock', { defaultValue: "可售库存" }),
                value: 0,
            }, {
                label: this.$t('fbb.inbound.unavailable_stock', { defaultValue: "不可售库存" }),
                value: 1,

            }]
        },
        getTransportType() {
            return [{
                label: this.$t('fbb.alloment.warehouse_arrangement', { defaultValue: "仓库安排" }),
                value: 2,
            }, {
                label: this.$t('fbb.alloment.client_arrangement', { defaultValue: "客户安排" }),
                value: 1,
            }]
        },
        getBillManageStatus(){
            // DRAFT(0,"草稿"),
            // REJECT(3,"已驳回"),
            // SUBMITTED(5,"待审核"),
            // CONFIRMED(10,"待出库"),
            // OUTBOUND(15,"出库中"),
            // OUTBOUNDED(20,"已出库"),
            // INBOUND(25,"入库中"),
            // COMPLETED(70,"已完成"),
            // CLOSED(90,"已关闭"),
            // CANCELING(100,"取消中"),
            // CANCELED(110,"已取消"),
            // CANCEL_ERROR(120,"取消异常")
            return [ {
                label: this.$t('fbb.alloment.audit', { defaultValue: "待审核" }),
                value: 5,
                theme: 'info'
            }, {
                label: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                value: 3,
                theme: 'error'
            }, {
                label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                value: 7,
                theme: 'info'
            }, {
                label: this.$t('fbb.alloment.wait_for_outbound', { defaultValue: "待出库" }),
                value: 10,
                theme: 'info'
            }, {
                label: this.$t('fbb.alloment.outbounding', { defaultValue: "出库中" }),
                value: 15,
                theme: 'warning'
            }, {
                label: this.$t('fbb.alloment.wait_for_inbound', { defaultValue: "待入库" }),
                value: 20,
                theme: 'primary'
            }/* , {
                label: "待入库",
                value: 24,
                theme: 'primary'
            } */, {
                label: this.$t('fbb.alloment.inbounding', { defaultValue: "入库中" }),
                value: 25,
                theme: 'primary'
            }, {
                label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                value: 70,
                theme: 'success'
            },/*  {
                label: "已关闭",
                value: 90
            }, {
                label: "取消中",
                value: 100,
            }, */ {
                label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                value: 110,
                theme: 'error'
            }]
        },
        getBillStatus() {
            // DRAFT(0,"草稿"),
            // REJECT(3,"已驳回"),
            // SUBMITTED(5,"待审核"),
            // CONFIRMED(10,"待出库"),
            // OUTBOUND(15,"出库中"),
            // OUTBOUNDED(20,"已出库"),
            // INBOUND(25,"入库中"),
            // COMPLETED(70,"已完成"),
            // CLOSED(90,"已关闭"),
            // CANCELING(100,"取消中"),
            // CANCELED(110,"已取消"),
            // CANCEL_ERROR(120,"取消异常")
            return [{
                label: this.$t('fbb.alloment.draft', { defaultValue: "草稿" }),
                value: 0
            }, {
                label: this.$t('fbb.alloment.audit', { defaultValue: "待审核" }),
                value: 5,
                theme: 'warning'
            }, {
                label: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                value: 3,
                theme: 'error'
            }, {
                label: this.$t('fbb.alloment.auditing', { defaultValue: "审核中" }),
                value: 6,
                theme: 'warning'
            },
            {
                label: this.$t('fbb.inbound.pass_audit', { defaultValue: "审核通过" }),
                value: 7,
                theme: 'info'
            }, {
                label: this.$t('fbb.alloment.confirm', { defaultValue: "待确认" }),
                value: 8,
                theme: 'success'
            }, {
                label: this.$t('fbb.transfer.preparedgoods', { defaultValue: "待备货" }),
                value: 9,
                theme: 'warning'
            }, {
                label: this.$t('fbb.alloment.wait_for_outbound', { defaultValue: "待出库" }),
                value: 10,
                theme: 'primary'
            }, {
                label: this.$t('fbb.alloment.outbounding', { defaultValue: "出库中" }),
                value: 15,
                theme: 'gray'
            }, {
                label: this.$t('fbb.alloment.wait_for_inbound', { defaultValue: "待入库" }),
                value: 20,
                theme: 'primary'
            }/* , {
                label: "待入库",
                value: 24,
                theme: 'primary'
            } */, {
                label: this.$t('fbb.alloment.inbounding', { defaultValue: "入库中" }),
                value: 25,
                theme: 'gray'
            }, {
                label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                value: 70,
                theme: 'success'
            },/*  {
                label: "已关闭",
                value: 90
            }, {
                label: "取消中",
                value: 100,
            }, */ {
                label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                value: 110,
                theme: 'error'
            }, {
                label: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                value: 120,
                theme: 'error'
            }]
        },
        getBillStatusSelect() {
            // DRAFT(0,"草稿"),
            // REJECT(3,"已驳回"),
            // SUBMITTED(5,"待审核"),
            // CONFIRMED(10,"待出库"),
            // OUTBOUND(15,"出库中"),
            // OUTBOUNDED(20,"已出库"),
            // INBOUND(25,"入库中"),
            // COMPLETED(70,"已完成"),
            // CLOSED(90,"已关闭"),
            // CANCELING(100,"取消中"),
            // CANCELED(110,"已取消"),
            // CANCEL_ERROR(120,"取消异常")
            return [{
                label: this.$t('fbb.alloment.draft', { defaultValue: "草稿" }),
                value: 0
            }, {
                label: this.$t('fbb.alloment.audit', { defaultValue: "待审核" }),
                value: 5,
                theme: 'warning'
            }, {
                label: this.$t('fbb.alloment.refuse_audit', { defaultValue: "审核拒回" }),
                value: 3,
                theme: 'error'
            }, {
                label: this.$t('fbb.alloment.auditing', { defaultValue: "审核中" }),
                value: 6,
                theme: 'warning'
            },
           /*  {
                label: "审核通过",
                value: 7,
                theme: 'info'
            },  */{
                label: this.$t('fbb.alloment.confirm', { defaultValue: "待确认" }),
                value: 8,
                theme: 'success'
            }, {
                label: this.$t('fbb.alloment.wait_for_outbound', { defaultValue: "待出库" }),
                value: 10,
                theme: 'primary'
            }, {
                label: this.$t('fbb.alloment.outbounding', { defaultValue: "出库中" }),
                value: 15,
                theme: 'gray'
            }, {
                label: this.$t('fbb.alloment.wait_for_inbound', { defaultValue: "待入库" }),
                value: 20,
                theme: 'primary'
            }/* , {
                label: "待入库",
                value: 24,
                theme: 'primary'
            } */, {
                label: this.$t('fbb.alloment.inbounding', { defaultValue: "入库中" }),
                value: 25,
                theme: 'gray'
            }, {
                label: this.$t('global.common.finished', { defaultValue: "已完成" }),
                value: 70,
                theme: 'success'
            },/*  {
                label: "已关闭",
                value: 90
            }, {
                label: "取消中",
                value: 100,
            }, */ {
                label: this.$t('global.common.canceled', { defaultValue: "已取消" }),
                value: 110,
                theme: 'error'
            }, {
                label: this.$t('fbb.alloment.cancel_exception', { defaultValue: "取消异常" }),
                value: 120,
                theme: 'error'
            }]
        }
    },
}
